/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import React from "react";

import styled from "styled-components";

import {WealthyEnv} from "helpers";

const buttonArrow = `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-button-right-arrow.svg`;
const heroImage = `${WealthyEnv.HOMEPAGE_CDN_URL}/partner-page-hero-image-aditya.png`;

const Hero = () => {
  return (
    <HeroWrapper>
      <TextImageWrapper>
        <TextWrapper>
          <HeadingContainer>
            <h1 className="primary-heading hero-heading">India's top platform for Mutual Fund Distributors</h1>
            <Description>
              Earn 2X more, get trained, and assisted<br />
              by technology - at every step in your journey
            </Description>
            <GetStartedButton href="#register">
              Get Started
              <img alt="right-arrow-icon" className="button-arrow" loading="lazy" src={buttonArrow} />
            </GetStartedButton>
          </HeadingContainer>
        </TextWrapper>
        <ImageWrapper>
          <img alt="partner-hero-image" className="hero-image" loading="lazy" src={heroImage} />
        </ImageWrapper>
      </TextImageWrapper>
    </HeroWrapper>
  );
};

const HeroWrapper = styled.div`
  min-height: 800px;
`;

const TextImageWrapper = styled.div`
  width: 85%;
  margin: 0 auto;
  display: flex;
  height: 100vh;
  justify-content: space-between;

  @media (max-width: 768px) {
    justify-content: center;
    height: 100%;
    width: 90%;
    margin-top: 5rem;
    padding-bottom: 10rem;
  }
`;

const TextWrapper = styled.div`
  margin-top: 12rem;
  width: 45%;

  animation: scroll-top 400ms cubic-bezier(0.46,0.03,0.52,0.96) forwards;
  opacity: 0;
  animation-delay: 500ms;

  @keyframes scroll-top {
    from {
      transform: translateY(50px);
      opacity: 0;
    }

    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  @media (max-height: 600px) {
    margin-top: 8rem;
  }

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 0;
  }
`;

const HeadingContainer = styled.div`
  align-self: center;

  .primary-heading.hero-heading {
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.27;
    letter-spacing: normal;
    text-align: left;
    color: #1C1C1C;
    font-size: 3.8vw;
    font-family: MavenPro-Bold;
  }

  @media (max-width: 1366px) {
    .primary-heading.hero-heading {
      font-size: 5rem;
    }
  }

  @media (max-width: 1300px) {
    .primary-heading.hero-heading {
      font-size: 4.8rem;
    }
  }

  @media (max-width: 1260px) {
    .primary-heading.hero-heading {
      font-size: 4.5rem;
    }
  }

  @media (max-width: 768px) {
    margin-top: 4rem;

    .primary-heading.hero-heading {
      font-size: 3.4rem;
      line-height: 1.5;
      text-align: center;
    }
  }
`;

const Description = styled.div`
  margin-top: 4rem;
  font-family: MavenPro;
  font-size: 1.8rem;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: normal;
  text-align: left;
  color: #7E7E7E;

  @media (max-width: 768px) {
    font-size: 1.8rem;
    line-height: 1.67;
    text-align: center;
  }
`;

const GetStartedButton = styled.a`
  margin-top: 5rem;
  width: 18rem;
  height: 5.6rem;
  border-radius: 1.2rem;
  background-color: #6725F4;
  border: none;
  font-size: 1.8rem;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;

  .button-arrow {
    margin-left: 1rem;
    vertical-align: middle;
    :hover {
      transition: all 300ms cubic-bezier(0.46,0.03,0.52,0.96);
      transform: rotate(360deg);
    }
  }

  :hover {
    transition: all 600ms cubic-bezier(0.46,0.03,0.52,0.96);
    transform: scale(1.02);
  }


  @media (max-width: 768px) {
    margin: 10rem auto 0;
    font-size: 1.8rem;
    padding: 1.6rem;
  }
`;

const ImageWrapper = styled.div`
  width: 50%;
  animation: scroll-top 500ms cubic-bezier(0.46,0.03,0.52,0.96) forwards;
  opacity: 0;
  animation-delay: 800ms;
  height: 100%;
  align-self: flex-end;
  margin-bottom: 6rem;

  @keyframes scroll-top {
    from {
      transform: translateY(200px);
      opacity: 0;
    }

    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  .hero-image {
    width: 100%;
    object-fit: contain;
    height: 100%;
  }

  @media (max-width: 948px) {
    display: none;
  }

  @media (max-height: 660px) {
    width: 43%;
  }

  @media (max-height: 600px) {
    width: 40%;
  }
`;

export default Hero;
